import { LmiContractConfig } from './types';
import { maLmiContractConfig } from './ma-config';
import { mdLmiContractConfig } from './md-config';
import { mnLmiContractConfig } from './mn-config';
import { njLmiContractConfig } from './nj-config';
import { nyLmiContractConfig } from './ny-config';
import { vaLmiContractConfig } from './va-config';

export const stateConfigs: Record<string, LmiContractConfig> = {
  MD: mdLmiContractConfig,
  NJ: njLmiContractConfig,
  NY: nyLmiContractConfig,
  MN: mnLmiContractConfig,
  VA: vaLmiContractConfig,
  MA: maLmiContractConfig,
};

export { maLmiContractConfig } from './ma-config';
export { mdLmiContractConfig } from './md-config';
export { mnLmiContractConfig } from './mn-config';
export { njLmiContractConfig } from './nj-config';
export { nyLmiContractConfig } from './ny-config';
export { vaLmiContractConfig } from './va-config';
export * from './types';
